export function dropdownSelect(data,type) {
    if(type === "applicant"){
        let array = ["blood_type","religion","race","passport_type","marital_status",
                    "interview_status", "recruited_from"];
        for(const key in data){
            if(data[key] === null && array.includes(key)){
                data[key] = '';
            }
        }
    }
    else if (type === "listView"){
        let array2 = ["blood_type","job_category_uid","interview_status", "marital_status",
                    "religion","passport_type","edu_history", "recruited_from", "eyesight","glass_botheye","eyesight_botheye"];
        for(const key in data){
            if(data[key] === null && array2.includes(key)){
                data[key] = '';
            }
        }
    }
    else if(type === "nrc"){
        for(const key in data){
            if(data[key] === null){
                data[key] = '';
            }
        }
    }
    else{
        if(data["job_category_uid"] === null){
            data["job_category_uid"] = '';
        }
    }
    return data;
}